import React from "react";
import styled from "styled-components";
import Contact from "../../components/contact/Contact";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";

const Container = styled.div`
  width: 1200px;
  margin: 0 auto;
  padding: 0 50px;
  @media screen and (max-width: 480px) {
    width: 100%;
    margin: 0;
    padding: 0;
  }
`;

const ContactPage = () => {
  return (
    <>
      <Container>
        <Header />
        <Contact />
      </Container>
      <div style={{ backgroundColor: "#2f3133", color: "white" }}>
        <Footer />
      </div>
    </>
  );
};

export default ContactPage;
